module.exports = __webpack_public_path__ + "static/media/logoOuvidoria.0e89ae0d.svg";